import Form from '../_.extend';
import { onSuccess, onError } from './form/hooks';
import { getFields } from './form/fields';
import { getLabels } from './form/labels';
import { getRules } from './form/rules';
import { getExtra } from './form/extra';

// make fields
export const makeFields = (t: Function, localState: Object) => {
  const fields = getFields();
  const labels = getLabels(t, localState);
  const rules = getRules(localState);
  const extra = getExtra(t, localState);

  return { fields, labels, rules, extra };
};

// Form instance
class LicenseRequestForm extends Form {}

// make hooks
export const createLicenseRequestForm = (
  fieldOptions: Array<*>,
  localState: Object,
  t: Function
) => {
  const hooks = {
    onSuccess: onSuccess(localState, t),
    onError: onError(localState, t),
  };

  return new LicenseRequestForm(fieldOptions, { hooks });
};
